// extracted by mini-css-extract-plugin
export default {"card":"ThreejsModel_card__iXxrY"};